import React, {useState, useEffect, useRef, useContext} from 'react';
import util from 'common/util'
import {MapContext} from '_context/MapContext';
import {LayoutContext} from '_context/LayoutContext';
import {ollehModule} from '../../common/mapAPIExport'

const SearchProcess = (props) => {
    /*
        proos 설명
          poiResult (type:Object) - poi결과 검색API사양서참조
          selectPoiId (type:string)- 외부에서 선택을 요청하는 poiID --> 해당POI가 선택되어지며 이동되게 구현함.
          expandStatus (type:{id:'zzzz', status:true})- 외부에서 선택을 요청하는 poiID --> 해당POI가 선택되어지며 이동되게 구현함.
          poiClick (type:Function) - 지도상에 POI클릭시 이벤트가 fire하여 등록된 함수를 호출한다.
          addressVisible(type:boolen) - 주소에 폴리곤을 보이기 or 감추기
    */
    const currMaker = useRef();
    const {ktMapIns, poiResult, selectedId, opts, routes} = useContext(MapContext);
    const { status } = useContext(LayoutContext);

    useEffect(() => {
        if(poiResult){
            markerMapDisplay();
            infoWindowOpen(null)
        }else{
            if(ktMapIns){
                markerClear()
                addressClear()
                subMarkerClear()
                infoWindowOpen(null)
            }
        }
    }, [poiResult]);

    useEffect(() => {
        if(status && status!='search'){
            markerShowHide(false);
        }
    }, [status]);

    useEffect(() => {
        if(ktMapIns){
            markerClear()
            addressClear()
            subMarkerClear()
        }
    }, [routes]);

    useEffect(() => {
        if(ktMapIns){
            subMarkerClear(true, selectedId)
        }
        if(selectedId && selectedId.length===36 && ktMapIns['currMakers'] && ktMapIns['currMakers'].length>0){
            poiMapFocus();
        }
        if(selectedId && selectedId.length<24 && ktMapIns['currAddress'] && ktMapIns['currAddress'].length>0){
            addressMapFocus();
        }
    }, [selectedId]);

    useEffect(() => {
        if(ktMapIns && opts.expand){
            if(opts.expand.status){
                subMarkerMapDisplay(opts.expand.id)
            }else{
                subMarkerClear();
                infoWindowOpen(currMaker.current)
            }
        }
    }, [opts.expand]);

    useEffect(() => {
        if(ktMapIns){
            addressShowHide(opts.isAddr)
        }
    }, [opts.isAddr]);

    const markerMapDisplay = ()=>{
        if(!ktMapIns){
            return
        }
        markerClear()
        addressClear()
        subMarkerClear()
        if(Object.keys(poiResult).length < 1){
          return
        }
        let poiBound = null
        ktMapIns['poiResult'] = poiResult
        poiResult.pois.forEach((element, idx) => {
            let latLngPoint = new ollehModule.maps.LatLng(element.point.lat, element.point.lng);
            let point = ollehModule.maps.UTMK.valueOf(latLngPoint);
            let marker = new ollehModule.maps.overlay.CustomMarker({
                position: point,
                map:ktMapIns,
                label:String.fromCharCode(65+idx),
            });
            marker['attribute'] = element
            marker.id = element.id
            marker.label = String.fromCharCode(65+idx)
            marker.onEvent('click', function(e) {
                e.stopPropagation()
                props.poiClick(e, marker.id)
                infoWindowOpen(marker)
            });
            ktMapIns['currMakers'].push(marker);
            poiBound = idx===0 ? new ollehModule.maps.Bounds(point, point) : poiBound.union(point);
        });

        let addressBound = null
        poiResult.residentialAddress.some((element, idx) => {
            if(element.roadAddress && element.roadAddress.length>0){
                element.roadAddress.some((roadElement) => {
                    if(roadElement.geographicInformation && roadElement.geographicInformation.shape){
                        let result = null
                        if(roadElement.geographicInformation.shape.type==='MultiPolygon' || roadElement.geographicInformation.shape.type==='Polygon'){
                            result = util.shapeToPolygons(roadElement.geographicInformation.shape, opts.isAddr?ktMapIns:null)
                            ktMapIns['currAddress'].push({id:roadElement.rbucode, shapes:result.polygons, bound:result.bound});
                        }else{
                            result = util.shapeToPolyline(roadElement.geographicInformation.shape, opts.isAddr?ktMapIns:null)
                            ktMapIns['currAddress'].push({id:roadElement.rbucode, shapes:result.polylines, bound:result.bound});
                        }
                        if(idx===0){
                            addressBound = result.bound
                        }
                    }
                })
                return false;
            }
            element.parcelAddress.some((placeElement) => {
                if(placeElement.geographicInformation && placeElement.geographicInformation.shape){
                    let result = util.shapeToPolygons(placeElement.geographicInformation.shape, opts.isAddr?ktMapIns:null)
                    if(idx===0){
                        addressBound = result.bound
                    }
                    ktMapIns['currAddress'].push({id:placeElement.pnucode, shapes:result.polygons, bound:result.bound});
                }else{
                    let point = new ollehModule.maps.UTMK(placeElement.geographicInformation.utmkPoint.x, placeElement.geographicInformation.utmkPoint.y);
                    let marker = new ollehModule.maps.overlay.CustomMarker({position:point, map:ktMapIns, label:'P'});
                    ktMapIns['currAddress'].push({id:placeElement.pnucode, shapes:[marker], point:new ollehModule.maps.UTMK(placeElement.geographicInformation.utmkPoint.x, placeElement.geographicInformation.utmkPoint.y)})
                    ktMapIns.setCenter(point);
                    if(ktMapIns.getZoom()<11){
                        ktMapIns.setZoom(11);
                    }
                }
            })
        })

        // if(addressBound){
        //     ktMapIns.fitBounds(addressBound);
        // }else if(poiBound){
        //     ktMapIns.fitBounds(poiBound);
        // }
    }

    const subMarkerMapDisplay = (poiId)=>{
        subMarkerClear();
        let parentMarker = null
        if(poiId === selectedId){
            parentMarker = currMaker.current
        }else{
            ktMapIns['currMakers'].forEach((marker, idx) => {
                if(marker.id === poiId){
                    parentMarker = marker
                    return
                }
            });
        }
        if(parentMarker.attribute && parentMarker.attribute.children){
            parentMarker.attribute.children.forEach((element, idx) => {
                var latLngPoint = new ollehModule.maps.LatLng(element.point.lat, element.point.lng);
                var point = ollehModule.maps.UTMK.valueOf(latLngPoint);
                let marker = new ollehModule.maps.overlay.CustomMarker({
                    position: point,
                    map:ktMapIns,
                    label:parentMarker.label + (idx+1),
                    className:'markerBg_custom relevantPlace'
                });
                marker['attribute'] = element
                marker.id = element.id
                marker.pid = parentMarker.id
                marker.onEvent('click', function(e) {
                    e.stopPropagation()
                    props.poiClick(e, marker.id)
                    infoWindowOpen(marker)
                });
                ktMapIns['currSubMakers'].push(marker);
            })
        }
    }

    const markerClear = ()=>{
        if(ktMapIns['currMakers']){
            ktMapIns['currMakers'].forEach((marker, idx) => {
                marker.setMap(null);
            });
        }
        ktMapIns['currMakers'] = [];
    } 

    const subMarkerClear = (check, id)=>{
        let clear = true
        if(check && ktMapIns['currSubMakers']){
            ktMapIns['currSubMakers'].forEach((marker, idx) => {
                if(id===marker.id || id===marker.pid){
                    clear = false
                    return
                }
            });
        }
        if(clear){
            if(ktMapIns['currSubMakers']){
                ktMapIns['currSubMakers'].forEach((marker, idx) => {
                    marker.setMap(null);
                });
            }
            ktMapIns['currSubMakers'] = [];
        }
    }

    const markerShowHide = (show)=>{
        if(ktMapIns['currMakers']){
            ktMapIns['currMakers'].forEach((marker, idx) => {
                if(show){
                    marker.setMap(ktMapIns);
                }else{
                    marker.setMap(null);
                }
            });
        }
        if(ktMapIns['currSubMakers']){
            ktMapIns['currSubMakers'].forEach((marker, idx) => {
                if(show){
                    marker.setMap(ktMapIns);
                }else{
                    marker.setMap(null);
                }
            });
        }
    } 

    const addressClear = ()=>{
        if(ktMapIns['currAddress']){
            ktMapIns['currAddress'].forEach((address, idx) => {
                address.shapes.forEach((shape) => {
                    shape.setMap(null);
                })
            });
        }
        ktMapIns['currAddress'] = [];
    }

    const addressShowHide = (show)=>{
        if(ktMapIns['currAddress']){
            ktMapIns['currAddress'].forEach((address, idx) => {
                address.shapes.forEach((shape) => {
                    if(show){
                        shape.setMap(ktMapIns);
                    }else{
                        shape.setMap(null);
                    }
                })
            });
        }
    }

    // const poiRetrive = (poiId)=>{
    //     ktMapIns['currMakers'].forEach((marker, idx) => {
    //         if(marker.id === poiId){
    //             return marker
    //         }
    //     });
    //     return null
    // }

    // const addressRetrive = (pnu)=>{
    //     ktMapIns['currAddress'].forEach((address, idx) => {
    //         if(address.id === pnu){
    //             return address
    //         }
    //     });
    //     return null
    // }

    // const subPoiRetrive = (poiId)=>{
    //     ktMapIns['currSubMakers'].forEach((marker, idx) => {
    //         if(marker.id === poiId){
    //             return marker
    //         }
    //     });
    //     return null
    // }

    const poiMapFocus = ()=>{
        var matchMarker = null
        ktMapIns['currMakers'].forEach((marker, idx) => {
            marker.setZIndex(841683);
            marker.elements.upper_overlay_pane[0].children[0].children[0].className='markerBg_custom'
            if(marker.id === selectedId){
                matchMarker = currMaker.current = marker
                marker.elements.upper_overlay_pane[0].children[0].children[0].className='markerBg_custom selected number'
                marker.setZIndex(ollehModule.maps.overlay.BaseOverlay.MAX_ZINDEX);
            }
        });
        //if(!matchMarker){
            ktMapIns['currSubMakers'].forEach((marker, idx) => {
                marker.setZIndex(841683);
                marker.elements.upper_overlay_pane[0].children[0].children[0].className='markerBg_custom relevantPlace'
                if(marker.id === selectedId){
                    matchMarker = marker
                    marker.elements.upper_overlay_pane[0].children[0].children[0].className='markerBg_custom relevantPlace selected number'
                    marker.setZIndex(ollehModule.maps.overlay.BaseOverlay.MAX_ZINDEX);
                }
            });
        //}
        if(!matchMarker){
            return
        }
        var boundTimer
        boundTimer = setInterval(function() {
            clearInterval(boundTimer);
            let position = matchMarker.getPosition();
            let center = ktMapIns.getCenter()
            center.x = position.x
            center.y = position.y
            ktMapIns.setCenter(center);
            if(ktMapIns.getZoom()<11){
                ktMapIns.setZoom(11);
            }
            infoWindowOpen(matchMarker)
        },50);
    }

    const addressMapFocus = ()=>{
        infoWindowOpen(null)
        ktMapIns['currAddress'].forEach((address, idx) => {
            if(address.id === selectedId){
                if(address.bound){
                    ktMapIns.fitBounds(address.bound);
                }else{
                    let position = address.point
                    let center = ktMapIns.getCenter()
                    center.x = position.x
                    center.y = position.y
                    ktMapIns.setCenter(center);
                    if(ktMapIns.getZoom()<11){
                        ktMapIns.setZoom(11);
                    }
                }
                return
            }
        });
    }

    const infoWindowOpen = (marker)=>{
        props.infoWindow(marker)
    }

    return ('');
}

export default SearchProcess;